import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import AdminPage from '@/pages/AdminPage';
import '@/App.css';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);

  // Check for persistent login on mount
  useEffect(() => {
    const isAuth = localStorage.getItem('go_time_authenticated') === 'true';
    setAuthenticated(isAuth);
  }, []);

  const handleLogin = () => {
    setAuthenticated(true);
    setShowAdmin(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('go_time_authenticated');
    localStorage.removeItem('go_time_username');
    setAuthenticated(false);
  };

  const handleAdminClick = () => {
    setShowAdmin(true);
  };

  const handleBackFromAdmin = () => {
    setShowAdmin(false);
  };

  return (
    <BrowserRouter>
      <div className="App">
        {authenticated ? (
          <DashboardPage onLogout={handleLogout} />
        ) : showAdmin ? (
          <AdminPage onBack={handleBackFromAdmin} />
        ) : (
          <LoginPage onLogin={handleLogin} onAdminClick={handleAdminClick} />
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
